module.exports = __webpack_public_path__ + "static/media/iStock-1164414770.48e4ca4a.jpg";